import { StyledReactSelect } from './StyledReactSelect';

export default StyledReactSelect;
